import { PageHeader } from "@/components/PageHeader";
import { ModuleEmbedFrame } from "@/components/ModuleEmbedFrame";
import type { IntegratedModuleId } from "@/core/config";

interface ModuleEmbedPageProps {
  moduleId: IntegratedModuleId;
  targetPath: string;
  title: string;
  description?: string;
  /** Plein écran sans titre dupliqué (intégration stock). */
  compact?: boolean;
}

export function ModuleEmbedPage({
  moduleId,
  targetPath,
  title,
  description,
  compact = false,
}: ModuleEmbedPageProps) {
  if (compact) {
    return (
      <div className="ph-embed-page ph-embed-page--compact">
        <ModuleEmbedFrame moduleId={moduleId} targetPath={targetPath} title={title} />
      </div>
    );
  }

  return (
    <div className="ph-embed-page">
      <PageHeader title={title} description={description} />
      <ModuleEmbedFrame moduleId={moduleId} targetPath={targetPath} title={title} />
    </div>
  );
}
